(function () {
  class ChooseYourPlanCard {
    constructor(cardEl) {
      this.card = cardEl;
      this.cardType = cardEl.dataset.cardType;
      this.form = cardEl.querySelector('.cyp-product-form');
      this.dynamicInputs = cardEl.querySelector('.cyp-dynamic-inputs');
      this.mainVariantInput = cardEl.querySelector('.cyp-main-variant-id');
      this.submitBtn = cardEl.querySelector('.cyp-submit-btn');
      this.sectionRoot = cardEl.closest('.choose-your-plan');

      this.sellingPlanId = cardEl.dataset.sellingPlanId || '';
      this.gift1Id = cardEl.dataset.gift1Id || '';
      this.gift2Id = cardEl.dataset.gift2Id || '';
      this.gift1Available = cardEl.dataset.gift1Available !== 'false';
      this.gift2Available = cardEl.dataset.gift2Available !== 'false';
      this.minTotalQty = parseInt(cardEl.dataset.minTotalQty || '1', 10);
      this.maxTotalQty = parseInt(cardEl.dataset.maxTotalQty || '2', 10);

      const variantsJson = this.sectionRoot?.querySelector('[data-cyp-variants]');
      this.variants = variantsJson ? JSON.parse(variantsJson.textContent) : [];

      this.init();
    }

    init() {
      if (this.cardType === 'partner') {
        this.bindQtySteppers();
      } else {
        this.bindFlavorRadios();
        if (this.cardType === 'onetime') {
          this.bindOnetimeQty();
        }
      }

      if (this.form) {
        this.form.addEventListener('submit', () => this.updateFormInputs(), true);
      }

      this.updateFormInputs();
    }

    bindFlavorRadios() {
      const radios = this.card.querySelectorAll('.cyp-flavor-radio');
      radios.forEach((radio) => {
        radio.addEventListener('change', () => {
          if (!radio.checked) return;
          this.card.querySelectorAll('.cyp-flavor-option').forEach((opt) => {
            opt.classList.toggle('is-selected', opt.contains(radio));
          });
          this.updateFormInputs();
        });
      });

      const checked = this.card.querySelector('.cyp-flavor-radio:checked');
      if (checked) {
        checked.closest('.cyp-flavor-option')?.classList.add('is-selected');
      }
    }

    bindQtySteppers() {
      this.card.querySelectorAll('.cyp-flavor-qty-item').forEach((item) => {
        const input = item.querySelector('.cyp-qty-input');
        const display = item.querySelector('[data-cyp-qty-display]');
        const min = parseInt(item.dataset.min || '0', 10);
        const max = parseInt(item.dataset.max || '2', 10);

        item.querySelectorAll('.cyp-qty-btn').forEach((btn) => {
          btn.addEventListener('click', () => {
            let qty = parseInt(input.value || '0', 10);
            if (btn.dataset.action === 'increase') {
              const totalQty = this.getPartnerTotalQty();
              const otherQty = totalQty - qty;
              const maxAllowed = Math.min(max, this.maxTotalQty - otherQty);
              qty = Math.min(maxAllowed, qty + 1);
            } else {
              qty = Math.max(min, qty - 1);
            }
            input.value = qty;
            if (display) display.textContent = qty;
            this.updateFormInputs();
          });
        });
      });
    }

    bindOnetimeQty() {
      this.onetimeQtyRoot = this.card.querySelector('[data-cyp-onetime-qty]');
      if (!this.onetimeQtyRoot) return;

      this.onetimeQtyInput = this.onetimeQtyRoot.querySelector('[data-cyp-onetime-qty-input]');
      this.onetimeQtyDisplay = this.onetimeQtyRoot.querySelector('[data-cyp-onetime-qty-display]');
      this.onetimeQtyMinus = this.onetimeQtyRoot.querySelector('[data-cyp-onetime-qty-minus]');
      this.onetimeQtyPlus = this.onetimeQtyRoot.querySelector('[data-cyp-onetime-qty-plus]');
      this.onetimeQtyMin = parseInt(this.onetimeQtyRoot.dataset.min || '1', 10);
      this.onetimeQtyMax = parseInt(this.onetimeQtyRoot.dataset.max || '10', 10);

      if (this.onetimeQtyMinus) {
        this.onetimeQtyMinus.addEventListener('click', () => {
          const qty = Math.max(this.onetimeQtyMin, this.getOnetimeQuantity() - 1);
          this.setOnetimeQuantity(qty);
          this.updateFormInputs();
        });
      }

      if (this.onetimeQtyPlus) {
        this.onetimeQtyPlus.addEventListener('click', () => {
          const qty = Math.min(this.onetimeQtyMax, this.getOnetimeQuantity() + 1);
          this.setOnetimeQuantity(qty);
          this.updateFormInputs();
        });
      }

      this.updateOnetimeQtyButtons();
    }

    getOnetimeQuantity() {
      if (!this.onetimeQtyInput) return 1;
      const value = parseInt(this.onetimeQtyInput.value, 10);
      if (!Number.isFinite(value)) return this.onetimeQtyMin || 1;
      return Math.min(this.onetimeQtyMax || 10, Math.max(this.onetimeQtyMin || 1, value));
    }

    setOnetimeQuantity(quantity) {
      if (!this.onetimeQtyInput) return;
      this.onetimeQtyInput.value = quantity;
      if (this.onetimeQtyDisplay) this.onetimeQtyDisplay.textContent = quantity;
      this.updateOnetimeQtyButtons();
    }

    updateOnetimeQtyButtons() {
      if (!this.onetimeQtyInput) return;

      const quantity = this.getOnetimeQuantity();
      const min = this.onetimeQtyMin || 1;
      const max = this.onetimeQtyMax || 10;

      if (this.onetimeQtyMinus) {
        this.onetimeQtyMinus.disabled = quantity <= min;
      }
      if (this.onetimeQtyPlus) {
        this.onetimeQtyPlus.disabled = quantity >= max;
      }
    }

    updateQtyStepperStates() {
      if (this.cardType !== 'partner') return;

      const totalQty = this.getPartnerTotalQty();

      this.card.querySelectorAll('.cyp-flavor-qty-item').forEach((item) => {
        const input = item.querySelector('.cyp-qty-input');
        const min = parseInt(item.dataset.min || '0', 10);
        const max = parseInt(item.dataset.max || '2', 10);
        const qty = parseInt(input?.value || '0', 10);
        const otherQty = totalQty - qty;
        const maxAllowed = Math.min(max, this.maxTotalQty - otherQty);

        item.querySelectorAll('.cyp-qty-btn').forEach((btn) => {
          if (btn.dataset.action === 'increase') {
            btn.disabled = qty >= maxAllowed;
          } else {
            btn.disabled = qty <= min;
          }
        });
      });
    }

    getSelectedVariantId() {
      const checked = this.card.querySelector('.cyp-flavor-radio:checked');
      return checked ? checked.value : null;
    }

    getPartnerQtyItems() {
      const items = [];
      this.card.querySelectorAll('.cyp-flavor-qty-item').forEach((item) => {
        const qty = parseInt(item.querySelector('.cyp-qty-input')?.value || '0', 10);
        if (qty > 0) {
          items.push({
            variantId: item.dataset.variantId,
            quantity: qty,
            available: item.dataset.available !== 'false',
          });
        }
      });
      return items;
    }

    getPartnerTotalQty() {
      return this.getPartnerQtyItems().reduce((sum, item) => sum + item.quantity, 0);
    }

    clearDynamicInputs() {
      if (this.dynamicInputs) this.dynamicInputs.innerHTML = '';
    }

    appendItemInput(index, variantId, quantity, sellingPlanId) {
      const idInput = document.createElement('input');
      idInput.type = 'hidden';
      idInput.name = `items[${index}][id]`;
      idInput.value = variantId;

      const qtyInput = document.createElement('input');
      qtyInput.type = 'hidden';
      qtyInput.name = `items[${index}][quantity]`;
      qtyInput.value = quantity;

      this.dynamicInputs.appendChild(idInput);
      this.dynamicInputs.appendChild(qtyInput);

      if (sellingPlanId) {
        const planInput = document.createElement('input');
        planInput.type = 'hidden';
        planInput.name = `items[${index}][selling_plan]`;
        planInput.value = sellingPlanId;
        this.dynamicInputs.appendChild(planInput);
      }
    }

    isVariantAvailable(variantId) {
      const variant = this.variants.find((v) => String(v.id) === String(variantId));
      return variant ? variant.available : false;
    }

    isGiftAvailable(giftKey) {
      if (giftKey === 'gift1') return this.gift1Id ? this.gift1Available : true;
      if (giftKey === 'gift2') return this.gift2Id ? this.gift2Available : true;
      return true;
    }

    updateFormInputs() {
      if (!this.dynamicInputs) return;

      this.clearDynamicInputs();
      let canSubmit = true;
      let itemIndex = 0;

      if (this.mainVariantInput) {
        this.mainVariantInput.removeAttribute('name');
      }

      if (this.cardType === 'partner') {
        const qtyItems = this.getPartnerQtyItems();
        const totalQty = this.getPartnerTotalQty();

        if (totalQty < this.minTotalQty || totalQty > this.maxTotalQty) canSubmit = false;

        qtyItems.forEach((item) => {
          this.appendItemInput(itemIndex++, item.variantId, item.quantity, this.sellingPlanId || null);
          if (!item.available || !this.isVariantAvailable(item.variantId)) canSubmit = false;
        });

        if (this.gift1Id) {
          this.appendItemInput(itemIndex++, this.gift1Id, 1, null);
          if (!this.isGiftAvailable('gift1')) canSubmit = false;
        }
        if (this.gift2Id) {
          this.appendItemInput(itemIndex++, this.gift2Id, 1, null);
          if (!this.isGiftAvailable('gift2')) canSubmit = false;
        }
      } else if (this.cardType === 'subscribe') {
        const variantId = this.getSelectedVariantId();
        if (!variantId) {
          canSubmit = false;
        } else {
          this.appendItemInput(itemIndex++, variantId, 1, this.sellingPlanId || null);
          if (!this.isVariantAvailable(variantId)) canSubmit = false;

          if (this.gift1Id) {
            this.appendItemInput(itemIndex++, this.gift1Id, 1, null);
            if (!this.isGiftAvailable('gift1')) canSubmit = false;
          }
          if (this.gift2Id) {
            this.appendItemInput(itemIndex++, this.gift2Id, 1, null);
            if (!this.isGiftAvailable('gift2')) canSubmit = false;
          }
        }
      } else if (this.cardType === 'onetime') {
        const variantId = this.getSelectedVariantId();
        if (!variantId) {
          canSubmit = false;
        } else if (this.mainVariantInput) {
          this.mainVariantInput.name = 'id';
          this.mainVariantInput.value = variantId;

          const quantity = this.getOnetimeQuantity();
          const qtyInput = document.createElement('input');
          qtyInput.type = 'hidden';
          qtyInput.name = 'quantity';
          qtyInput.value = quantity;
          this.dynamicInputs.appendChild(qtyInput);

          if (!this.isVariantAvailable(variantId)) canSubmit = false;
        }
      }

      if (this.submitBtn) {
        this.submitBtn.disabled = !canSubmit;
      }

      this.updateQtyStepperStates();
      this.updateOnetimeQtyButtons();
    }
  }

  function initChooseYourPlan() {
    document.querySelectorAll('.choose-your-plan').forEach((root) => {
      if (root.dataset.cypInitialized) return;
      root.dataset.cypInitialized = 'true';

      root.querySelectorAll('[data-cyp-card]').forEach((card) => {
        new ChooseYourPlanCard(card);
      });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initChooseYourPlan);
  } else {
    initChooseYourPlan();
  }

  document.addEventListener('shopify:section:load', initChooseYourPlan);
})();
